// Mapeia cada segmento (slug do segmentos-data) para a IA correspondente em /ia
export type SegmentIA = {
  slug: string; // slug usado na URL do formulário
  name: string;
  url: string;
};

export const SEGMENT_TO_IA: Record<string, SegmentIA> = {
  "farmacias": {
    slug: "farmacia",
    name: "IA Farmácia",
    url: "https://formulario.kentro.com.br/farmacia",
  },
  "clinicas-medicas": {
    slug: "medico",
    name: "IA Dr.",
    url: "https://formulario.kentro.com.br/medico",
  },
  "clinicas-odontologicas": {
    slug: "medico",
    name: "IA Dr.",
    url: "https://formulario.kentro.com.br/medico",
  },
  "provedores-de-internet": {
    slug: "provedor",
    name: "IA Provedor",
    url: "https://formulario.kentro.com.br/provedor",
  },
  "faculdades": {
    slug: "faculdade",
    name: "IA Faculdade",
    url: "https://formulario.kentro.com.br/faculdade",
  },
  "cursos-de-idiomas": {
    slug: "faculdade",
    name: "IA Faculdade",
    url: "https://formulario.kentro.com.br/faculdade",
  },
  "concessionarias": {
    slug: "vendedor",
    name: "IA Vendedor",
    url: "https://formulario.kentro.com.br/vendedor",
  },
  "condominios": {
    slug: "sdr",
    name: "IA Eva (SDR)",
    url: "https://formulario.kentro.com.br/sdr",
  },
  "lojas-de-informatica": {
    slug: "lojavirtual",
    name: "IA Loja Online",
    url: "https://formulario.kentro.com.br/lojavirtual",
  },
  "ecommerce": {
    slug: "lojavirtual",
    name: "IA Loja Online",
    url: "https://formulario.kentro.com.br/lojavirtual",
  },
  "clinicas": {
    slug: "medico",
    name: "IA Dr.",
    url: "https://formulario.kentro.com.br/medico",
  },
  "escolas-e-faculdades": {
    slug: "faculdade",
    name: "IA Faculdade",
    url: "https://formulario.kentro.com.br/faculdade",
  },
};

export function getIAForSegment(segmentSlug: string): SegmentIA | undefined {
  return SEGMENT_TO_IA[segmentSlug];
}
